
import  "./Focus.css";

const FocusUnit = function (props) {
    return (
        <React.Fragment>
        <div>

            <div className="siteText">
                <span className="mainTitleSiteText">{props.data.Title}</span>
                <span className="secTitleSiteText">{props.data.MODDFocusShortText}</span>
            </div>
            <div className="innerText" dangerouslySetInnerHTML={{__html: props.data.MODFocusMainText}}></div>
            <div className="focusReadMoreLink">
                <a href={props.data.MODFocusLink_Url} title={props.data.MODFocusLink_Description}>{props.data.MODFocusLink_Description}</a>
                <i className="fas fa-angle-left" />
            </div>
        </div> 
        <div>
             <img src={props.data.MODFocusImage.ImageUrl} data-holder-rendered="true"  alt="לוגו המוזיאון"/>
       </div>
    </React.Fragment>
    );
}
    export default FocusUnit;